/*eslint-disable*/
import React from 'react';
import { AccordionSection } from 'mapcontrols/components/subComponents';
import { DemographicsLayerItem } from './DemographicsLayerItem';
import { getDemographicsForPolytype, isDemographicValidForPolytype } from 'mapcontrols/constants';

const DemographicsSection = ({
  calculableBoundaryLayers = [],
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeSections = {},
  onSectionToggle = () => {},
  demographicSelection = null,
  onDemographicChange = () => {},
}) => {
  const currentDemographics = getDemographicsForPolytype(demographicSelection?.polytype);
  const handlePolytypeChange = (e) => {
    const newPolytype = e.target.value;
    const currentDemoglayer = demographicSelection?.demoglayer;

    // If no polytype selected, clear everything
    if (!newPolytype) {
      onDemographicChange('', '');
      return;
    }

    // Check if current demographic selection is valid for new polytype
    const shouldClearDemographic = currentDemoglayer && !isDemographicValidForPolytype(currentDemoglayer, newPolytype);

    if (shouldClearDemographic) {
      // Clear demographic selection when switching to incompatible boundary type
      onDemographicChange(newPolytype, '');
    } else {
      // Keep current demographic selection if it's valid for new boundary type
      onDemographicChange(newPolytype, currentDemoglayer || '');
    }
  };

  return (
    <AccordionSection
      title="Demographics"
      id="demographics"
      activeSections={activeSections}
      onSectionToggle={onSectionToggle}
      collapsedArrowIcon={collapsedArrowIcon}
      expandedArrowIcon={expandedArrowIcon}
    >
      <select
        className="leaflet-biglayerpanel-demographics-polytype"
        aria-label="Select an area type to show their demographics on the map"
        style={{
          backgroundImage: `url(${collapsedArrowIcon})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'calc(100% - 5px)',
        }}
        value={demographicSelection?.polytype || ''}
        onChange={handlePolytypeChange}
      >
        <option value="">Do not show demographics</option>
        {calculableBoundaryLayers.map((option, index) => (
          <option key={index} value={option.slug}>
            by {option.singular}
          </option>
        ))}
      </select>

      <fieldset>
        <legend></legend>
        {currentDemographics.map((item) => (
          <DemographicsLayerItem
            key={item.id}
            id={item.id}
            label={item.label}
            isReversed={item?.isReversed}
            isVisible={!!demographicSelection?.polytype}
            additionalText={item?.additionalText}
            isActive={demographicSelection?.demoglayer === item.id}
            onSelect={(demoglayer) => onDemographicChange(demographicSelection?.polytype || '', demoglayer)}
          />
        ))}
      </fieldset>
    </AccordionSection>
  );
};

export default DemographicsSection;
